import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=366c44af&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('366c44af')) {
      api.createRecord('366c44af', component.options)
    } else {
      api.reload('366c44af', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=366c44af&", function () {
      api.rerender('366c44af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NbHHp5A2ZRL/JS/comp/ImgFallback2.vue"
export default component.exports